'use strict';

function userService($http, $interpolate, $log) {
  var baseURL = '/api/core/user/';
  var singleURL = $interpolate('/api/core/user/{{id}}/');

  return {
    list: list,
    get: get,
    getGroups: getGroups,
    changeManager: changeManager,
    getEmployeesOfManager: getEmployeesOfManager,
    getEmployees: getEmployees,
    create: create,
    update: update,
    patch: patch,
    destroy: destroy,
    isValidEmail: isValidEmail
  };

  function list() {
    return $http.get(baseURL);
  }

  function get(id) {
    return $http.get(singleURL({ id: id })).then(function (response) {
      return response.data;
    });
  }

  function getGroups() {
    return $http.get(baseURL + '/groups').then(function (response) {
      return response.data;
    });
  }

  function changeManager(originalManagerId, employeeId, newManagerId) {
    return $http.post('/api/change_manager', {
      'original_manager': originalManagerId,
      'employee': employeeId,
      'new_manager': newManagerId
    }).then(function (response) {
      return response.data;
    });
  }

  function getEmployeesOfManager(id) {
    return $http.get(singleURL({ id: id }) + '/employees').then(function (response) {
      return response.data;
    });
  }

  function getEmployees() {
    return $http.get(baseURL + '/employees').then(function (response) {
      return response.data;
    });
  }

  function create(user) {
    $log.log('creating user in regular user service');
    return $http.post(baseURL, user);
  }

  function update(id, user) {
    return $http.put(singleURL({id: id}), user);
  }

  function patch(id, user) {
    return $http({url: singleURL({id: id}), method: 'PATCH', data: user});
  }

  function destroy(id) {
    return $http.delete(singleURL({id: id}));
  }

  function isValidEmail(address) {
    return /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$/.test(address);
  }
}

module.exports = userService;




/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/service/user/index.js
 ** module id = 170
 ** module chunks = 0
 **/